import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const postDesignation = ({commit, dispatch}, payload) => {
      
    
    axios.post('/designations/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
commit('unsetOverlayState')

        if(res.data.status) {
            
            dispatch('fetchDesignation')
            commit('setAlert', {message: 'Salvado'})   
             
        } else {
            commit('setAlertBox', {title: 'message.error', message: 'message.errorTryAgain'})        
        }

    })
    .catch(error => {

        
        console.log(error)
commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}

export const fetchDesignation = ({commit}) => {

    axios.get('/designations/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
commit('unsetOverlayState')
        commit('setDesignationList', res.data.response)    
        
    })
    .catch(error => {
        console.log(error)
        commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/designation/actions.js